import React from "react";

const PaginationComponent = ({ pages, currentPage, setCurrentPage }) => {

  function anterior() {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  }

  function proximo() {
    if (currentPage < pages - 1) {
      setCurrentPage(currentPage + 1);
    }
  }

  if (pages <= 1) return null;

  return (
    <ul className="pagination justify-content-end btn-cli">

      {/* ANTERIOR */}
      <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
        <button
          className="page-link"
          onClick={anterior}
          disabled={currentPage === 0}
        >
          Anterior
        </button>
      </li>

      {/* TEXTO CENTRAL */}
      <li className="page-item disabled">
        <span className="page-link">
          Página {currentPage + 1} de {pages}
        </span>
      </li>

      {/* PRÓXIMO */}
      <li className={`page-item ${currentPage === pages - 1 ? "disabled" : ""}`}>
        <button
          className="page-link"
          onClick={proximo}
          disabled={currentPage === pages - 1}
        >
          Próximo
        </button>
      </li>

    </ul>
  );
};

export default PaginationComponent;
